import Link, { LinkProps } from "next/link";
import { css } from "@nju/css";
import { Icon } from "@nju/icons";
import { BlockText, Box, Circle } from "@nju/ui";

interface IProps {
  isActive: boolean;
  url?: LinkProps["href"];
}

export function Marker({ isActive, url = "" }: IProps) {
  if (isActive) {
    return (
      <Box align="center" display="flex">
        <Radio isActive={isActive} />
        <BlockText className={styles.text()}>
          domyślna metoda płatności
        </BlockText>
      </Box>
    );
  } else {
    return (
      <Link className={styles.link({ isActive })} href={url} passHref={true}>
        <Radio isActive={isActive} />
        <BlockText className={styles.text()}>
          ustaw jako domyślną płatność
        </BlockText>
      </Link>
    );
  }
}

const styles = {
  text: css({
    pl: "$10",
  }),
  link: css({
    display: "flex",
    alignItems: "center",
    variants: {
      isActive: {
        false: {
          cursor: "pointer",
        },
      },
    },
    "&:focus P": {
      outline: "none",
      color: "$cerulean",
    },
  }),
};

function Radio({ isActive }: { isActive: boolean }) {
  return isActive ? (
    <Circle padding="xs" tone="accent">
      <Icon height={18} name="check" tone="secondary" width={18} />
    </Circle>
  ) : (
    <Circle padding="xs" tone="alternative">
      <span className={circleClass()} />
    </Circle>
  );
}

const circleClass = css({
  width: 18,
  height: 18,
  borderRadius: "$round",
  background: "$white",
});
